module.exports = __webpack_public_path__ + "img/Support-skill-201.ebeee01b.png";